import React from "react";
import { Download } from "lucide-react";
import { TspCard, TspBarChart } from "../../../components/primitives";
import { downloadBookWise } from "../dashboardDownloads";

// `series` (one per year shown) comes from the caller: the years the server
// returns are always the current and the two before it, but never hardcoded
// here so a year boundary never silently drops a column.
export default function BookWiseChart({ data, series }) {
  const hasBooks = (data || []).length > 0;

  return (
    <TspCard
      title="Book Wise Distribution Chart (Count)"
      className="tsp-dashboard-chart-card"
      action={
        <button type="button" className="tsp-download-text-btn" onClick={() => downloadBookWise(data, series)} disabled={!hasBooks} title="Download Excel">
          <Download size={14} /> Download
        </button>
      }
    >
      {hasBooks ? <TspBarChart data={data} xKey="name" series={series} /> : <p className="tsp-muted-text tsp-dashboard-chart-empty">No books distributed yet.</p>}
    </TspCard>
  );
}
